import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { IdempotencyService } from '../../services/idempotency.service';
import { SKIP_IDEMPOTENCY } from '../constants/context-tokens';

export const idempotencyInterceptor: HttpInterceptorFn = (req, next) => {
  const isMutating =
    (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE') && !req.context.get(SKIP_IDEMPOTENCY);
  if (isMutating) {
    const service = inject(IdempotencyService);
    service.setInProgress(true);
    if (req.method !== 'DELETE') {
      req = req.clone({ setHeaders: { 'Idempotency-Key': service.key } });
    }
    return next(req).pipe(
      finalize(() => {
        service.setInProgress(false);
        if (req.method !== 'DELETE') {
          service.refresh();
        }
      })
    );
  }
  return next(req);
};
